import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CourseContentMetadataService } from "src/app/_services/course-content-metadata.service";
import { GetActivityDetails, GetActivityDetailsError, GetActivityDetailsSuccess, GetResourceDetails, GetResourceDetailsError, GetResourceDetailsSuccess } from "./course-content-metadata.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { ActivityDetailsResultDto } from "src/app/_models/ActivityDetailResultDto";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";

@Injectable()
export class CourseContentMetadataEffects {
  constructor(
    private actions$: Actions,
    private courseContentMetadataService: CourseContentMetadataService
  ){}

  public getActivityDetailsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetActivityDetails),
      switchMap((payload) => 
        this.courseContentMetadataService.getActivityDetails$(payload.objectId).pipe(
          map((result: ActivityDetailsResultDto) => {
            return GetActivityDetailsSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetActivityDetailsError({error: error}));
          })
        )
      )
    )
  );

  public getResourceDetailsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetResourceDetails),
      switchMap((payload) => 
        this.courseContentMetadataService.getResourceDetails$(
            payload.objectId, 
            payload.courseId
          ).pipe(
          map((result: ActivityDetailsResultDto) => {
            return GetResourceDetailsSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetResourceDetailsError({error: error}));
          })
        )
      )
    )
  );
}